import styles from './styles.module.css';
import { AuthPageFrameProps } from './types';
import { cn } from '@/lib/utils';
import { Logo } from '@/shared/theme';

const AuthPageFrame = (props: AuthPageFrameProps) => {
  const {
    children,
    subtitle
  } = props;

  return (
    <div className={cn('flex min-h-screen items-center justify-center p-4', styles.frame)}>
      <section
        className={cn(
          'flex w-full max-w-[358px] flex-col gap-6 px-4 py-8',
          'text-foreground',
          'rounded-[var(--radius-20)] bg-surface shadow-none ring-1 ring-inset ring-border-strong'
        )}
      >
        <header className="flex flex-col items-center gap-6">
          <Logo
            className="h-8 w-[260.945px] max-w-none"
            height={32}
          />
          <p className="text-center font-sans text-sm font-normal leading-5 text-muted-foreground">{subtitle}</p>
        </header>
        {children}
      </section>
    </div>
  );
};

export default AuthPageFrame;